import { INICIALITZAR, SWITCH_MENU_GENERAL } from "../actions/actionTypes";

const ESTAT_INICIAL = false;

const menuLateral = (state = ESTAT_INICIAL, action) => {
  switch (action.type) {
    case INICIALITZAR:
      return ESTAT_INICIAL;

    case SWITCH_MENU_GENERAL:
      return !state;
    default:
      return state;
  }
};

export default menuLateral;

export const getvisibilitatMenuGeneral = state => state.menuLateral;
